import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {
	finetuneTranslationResources,
	sharedLanguageCodes,
} from '@etherworks/shared-i18n'

// Language configuration
export const languages = [
	{ code: 'en', name: 'English', nativeName: 'English' },
	{ code: 'zh', name: 'Chinese', nativeName: '中文' },
	{ code: 'ja', name: 'Japanese', nativeName: '日本語' },
	{ code: 'ko', name: 'Korean', nativeName: '한국어' },
	{ code: 'fr', name: 'French', nativeName: 'Français' },
] as const

export type LanguageCode = (typeof languages)[number]['code']

const resources = finetuneTranslationResources

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'en',
		supportedLngs: [...sharedLanguageCodes],
		
		detection: {
			// Order of language detection
			order: ['localStorage', 'navigator', 'htmlTag'],
			// Cache user language selection
			caches: ['localStorage'],
			// localStorage key
			lookupLocalStorage: 'etherworks-language',
		},

		interpolation: {
			escapeValue: false, // React already escapes values
		},

		react: {
			useSuspense: false, // Disable suspense to avoid loading issues
		},
	})

export default i18n
